<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head flex justify-between">
      <p class="modal-card-title">
        {{ notification.subject }}
      </p>
    </header>
    <section class="modal-card-body">
      <p>Received: {{ notification.createdAt | formatShortDateTime }}</p>
      <div class="wysiwyg-editor-container" v-html="notification.htmlContent" />

      <div class="flex grow grow-1 flex-wrap gap-x-4 gap-y-2 mt-2">
        <div v-for="attachment in attachments" :key="attachment.url"
          class="flex items-center p-2 bg-light-gray border rounded cursor-pointer"
          @click="downloadAttachment(attachment)" style="height:32px">
          <span class="text-sm text-truncate">
            {{ attachment.name }}
          </span>

          <d-icon icon="download" class="text-red ml-2 py-2 bg-transparent" />
        </div>
      </div>
    </section>
    <footer class="modal-card-foot justify-end">
      <d-btn flat @click="closeModalAndRefreshNotifications">
        Close
      </d-btn>
    </footer>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  props: {
    notification: {
      type: Object,
      default: () => { },
    },
  },

  data: () => ({
    attachments: [],
    downloadTimeout: undefined
  }),

  methods: {
    async closeModalAndRefreshNotifications() {

      var getUserNotifications = this.$parent.events?.getUserNotifications;
      if (getUserNotifications) {
        await getUserNotifications();
      }

      this.$parent.close();
    },

    async downloadAttachment(attachment) {
      clearTimeout(this.downloadTimeout);

      this.downloadTimeout = setTimeout(async () => {
        try {
          const response = await axios.get('/api/uploads', {
            responseType: 'blob',
            params: {
              url: attachment.url
            }
          });

          const url = window.URL.createObjectURL(new Blob([response.data]));

          // Create a link element
          const link = document.createElement('a');
          link.href = url;

          // Specify the file name
          link.setAttribute('download', attachment.name);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up the temporary URL
          window.URL.revokeObjectURL(url);

          link.remove();
        } catch (error) {
          this.$toast.open({ message: error.response, color: 'red-500', duration: 4000 });
        }
      }, 500);
    }
  },

  mounted() {
    const regex = /ATTACHMENTS\/(.*)$/;

    for (let i = 0; i < 3; i++) {
      const attachmentUrl = this.$props.notification[`attachmentUrl${i}`];
      if (attachmentUrl) {

        const name = attachmentUrl.match(regex)[1];

        this.attachments.push({
          name: name,
          url: attachmentUrl
        });
      }
    }
  }
};
</script>